var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GChart',{attrs:{"type":"LineChart","data":_vm.chartData,"options":_vm.chartOptions,"events":_vm.chartEvents}}),(
      _vm.showSecondChart && this.trafficTopStylistsIndividualSources.length > 0
    )?_c('GChart',{attrs:{"type":"LineChart","data":_vm.secondChartData,"options":_vm.secondChartOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }